module.exports = __webpack_public_path__ + "img/big_1_67.554d13da.png";